import script from "./StatusNoteText.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusNoteText.vue?vue&type=script&setup=true&lang=js"

import "./StatusNoteText.vue?vue&type=style&index=0&id=6f26fcd6&lang=scss&scoped=true"
import "./StatusNoteText.vue?vue&type=style&index=1&id=6f26fcd6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f26fcd6"]])

export default __exports__